import OtpModal from "./otp-modal.component";

export default OtpModal;
